import React, { useState, useRef, useCallback, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Mobilefotter from "./Mobilefotter.js";
import "../Components/Css/OnboardingForm.css";
import { handleError } from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  save_update_restaurant_onboarding,
} from "../ServiceConnection/serviceconnection";
import { FaStore, FaUserTie, FaMapMarkerAlt, FaShieldAlt, FaCheckCircle, FaBolt, FaUsers, FaChartLine } from "react-icons/fa";

const CAPTCHA_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // no O/0/I/1 — avoids confusion
const CAPTCHA_LENGTH = 6;

function generateCaptchaCode() {
  let code = "";
  for (let i = 0; i < CAPTCHA_LENGTH; i++) {
    code += CAPTCHA_CHARS[Math.floor(Math.random() * CAPTCHA_CHARS.length)];
  }
  return code;
}

function CaptchaCanvas({ code }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const { width, height } = canvas;

    ctx.clearRect(0, 0, width, height);

    ctx.fillStyle = "#f3f3f1";
    ctx.fillRect(0, 0, width, height);

    for (let i = 0; i < 6; i++) {
      ctx.strokeStyle = `rgba(115,115,115,${0.15 + Math.random() * 0.2})`;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(Math.random() * width, Math.random() * height);
      ctx.lineTo(Math.random() * width, Math.random() * height);
      ctx.stroke();
    }

    const charWidth = width / (code.length + 1);
    for (let i = 0; i < code.length; i++) {
      ctx.save();
      const x = charWidth * (i + 1);
      const y = height / 2 + (Math.random() * 10 - 5);
      ctx.translate(x, y);
      ctx.rotate((Math.random() * 30 - 15) * (Math.PI / 180));
      ctx.font = `${28 + Math.floor(Math.random() * 6)}px Georgia, serif`;
      ctx.fillStyle = `hsl(${Math.random() * 360}, 35%, 35%)`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(code[i], 0, 0);
      ctx.restore();
    }

    for (let i = 0; i < 40; i++) {
      ctx.fillStyle = `rgba(115,115,115,${Math.random() * 0.3})`;
      ctx.beginPath();
      ctx.arc(Math.random() * width, Math.random() * height, 1, 0, Math.PI * 2);
      ctx.fill();
    }
  }, [code]);

  return (
    <canvas
      ref={canvasRef}
      width={220}
      height={64}
      className="captchaCanvas"
      role="img"
      aria-label="Captcha verification code"
    />
  );
}

const OnboardingForm = () => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [form, setForm] = useState({
    restaurant_name: "",
    restaurant_phone: "",
    restaurant_email: "",
    owner_name: "",
    owner_email: "",
    owner_mobile: "",
    city: "",
  });
  const [errors, setErrors] = useState({});
  const [captchaCode, setCaptchaCode] = useState(generateCaptchaCode());
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const refreshCaptcha = useCallback(() => {
    setCaptchaCode(generateCaptchaCode());
    setCaptchaInput("");
    setCaptchaError("");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleSaveChangesdynamic = async () => {
    setshowLoaderAdmin(true);
    const form_data = new FormData();
    form_data.append("restaurant_name", form.restaurant_name);
    form_data.append("restaurant_phone", form.restaurant_phone);
    form_data.append("restaurant_email", form.restaurant_email);
    form_data.append("owner_name", form.owner_name);
    form_data.append("owner_email", form.owner_email);
    form_data.append("owner_mobile", form.owner_mobile);
    form_data.append("city", form.city);
    form_data.append("main_id", "0");

    await server_post_data(save_update_restaurant_onboarding, form_data)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setSubmitted(true);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    let hasError = false;

    Object.keys(form).forEach((field) => {
      if (!form[field] || form[field].trim() === "") {
        newErrors[field] = true;
        hasError = true;
      }
    });

    if (captchaInput.trim().toUpperCase() !== captchaCode) {
      setCaptchaError("Code doesn't match — try again.");
      hasError = true;
      refreshCaptcha();
    } else {
      setCaptchaError("");
    }

    setErrors(newErrors);
    if (hasError) return;

    handleSaveChangesdynamic();
  };

  return (
    <div className="howitworks_wrapper">
      <Header />

      <div className="onboardSplit">
        <div className="onboardIntro">
          <div className="onboardIntroInner">
            <span className="introEyebrow">Partner with Dfoodo</span>
            <h1>List your restaurant on Dfoodo</h1>
            <p className="introSub">
              Get discovered by diners across Bhopal in just a few minutes —
              no paperwork headaches, no waiting weeks.
            </p>

            <ul className="introBenefits">
              <li>
                <span className="benefitIcon"><FaBolt /></span>
                <div>
                  <strong>Go live fast</strong>
                  <p>Fill this form and our team verifies you within 24 hours.</p>
                </div>
              </li>
              <li>
                <span className="benefitIcon"><FaUsers /></span>
                <div>
                  <strong>Reach real diners</strong>
                  <p>Show up where thousands of people already search for food.</p>
                </div>
              </li>
              <li>
                <span className="benefitIcon"><FaChartLine /></span>
                <div>
                  <strong>Grow with insights</strong>
                  <p>Track orders, reviews, and reach from a single dashboard.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="onboardFormSide">
          {submitted ? (
            <div className="onboardCard successCard">
              <FaCheckCircle className="successIcon" />
              <h3>You're in 🎉</h3>
              <p>
                Restaurant details submitted successfully. Our team will
                reach out to complete verification.
              </p>
            </div>
          ) : (
            <form className="onboardCard" onSubmit={handleSubmit} noValidate>
              <div className="cardHead">
                <h3>Restaurant details</h3>
                <p className="subText">
                  Tell us about your restaurant to get started
                </p>
              </div>

              <div className="formSection">
                <span className="sectionLabel">
                  <FaStore /> Restaurant details
                </span>

                <div className="fieldGroup">
                  <label>Restaurant name</label>
                  <input
                    name="restaurant_name"
                    value={form.restaurant_name}
                    onChange={handleChange}
                    className={errors.restaurant_name ? "input-error" : ""}
                    placeholder="e.g. Spice Route"
                  />
                </div>

                <div className="rowGroup">
                  <div className="fieldGroup">
                    <label>Restaurant phone</label>
                    <input
                      name="restaurant_phone"
                      value={form.restaurant_phone}
                      onChange={handleChange}
                      className={errors.restaurant_phone ? "input-error" : ""}
                      placeholder="10-digit number"
                    />
                  </div>
                  <div className="fieldGroup">
                    <label>Restaurant email</label>
                    <input
                      type="email"
                      name="restaurant_email"
                      value={form.restaurant_email}
                      onChange={handleChange}
                      className={errors.restaurant_email ? "input-error" : ""}
                      placeholder="restaurant@example.com"
                    />
                  </div>
                </div>

                <div className="fieldGroup">
                  <label><FaMapMarkerAlt className="labelIcon" /> City</label>
                  <input
                    name="city"
                    value={form.city}
                    onChange={handleChange}
                    className={errors.city ? "input-error" : ""}
                    placeholder="e.g. Bhopal"
                  />
                </div>
              </div>

              <div className="formSection">
                <span className="sectionLabel">
                  <FaUserTie /> Owner details
                </span>

                <div className="fieldGroup">
                  <label>Owner name</label>
                  <input
                    name="owner_name"
                    value={form.owner_name}
                    onChange={handleChange}
                    className={errors.owner_name ? "input-error" : ""}
                    placeholder="Full name"
                  />
                </div>

                <div className="rowGroup">
                  <div className="fieldGroup">
                    <label>Owner email</label>
                    <input
                      type="email"
                      name="owner_email"
                      value={form.owner_email}
                      onChange={handleChange}
                      className={errors.owner_email ? "input-error" : ""}
                      placeholder="you@example.com"
                    />
                  </div>
                  <div className="fieldGroup">
                    <label>Owner mobile</label>
                    <input
                      name="owner_mobile"
                      value={form.owner_mobile}
                      onChange={handleChange}
                      className={errors.owner_mobile ? "input-error" : ""}
                      placeholder="10-digit number"
                    />
                  </div>
                </div>
              </div>

              <div className="formSection">
                <span className="sectionLabel">
                  <FaShieldAlt /> Verify you're human
                </span>
                <div className="captchaBlock">
                  <div className="captchaRow">
                    <CaptchaCanvas code={captchaCode} />
                    <button
                      type="button"
                      className="captchaRefresh"
                      onClick={refreshCaptcha}
                      aria-label="Refresh captcha"
                      title="Refresh code"
                    >
                      ↻
                    </button>
                  </div>
                  <input
                    name="captcha_input"
                    value={captchaInput}
                    onChange={(e) => setCaptchaInput(e.target.value)}
                    placeholder="Type the code above"
                    className={captchaError ? "input-error" : ""}
                    autoComplete="off"
                  />
                  {captchaError && (
                    <span className="errorText">{captchaError}</span>
                  )}
                </div>
              </div>

              <button
                type="submit"
                className="submitBtn"
                disabled={showLoaderAdmin}
              >
                {showLoaderAdmin ? "Submitting..." : "Submit"}
              </button>
            </form>
          )}
        </div>
      </div>

      <Mobilefotter />
      <Footer />
    </div>
  );
};

export default OnboardingForm;